/**
 * Categories (Classic) variant — barrel.
 *
 * Provides:
 *   - `CategoriesHub` — the daily / practice picker at `/categories`
 *   - `Categories`    — the playable surface (consumes `games/categories/engine.ts`)
 *   - `manifest`    — small descriptor used by the variant selector
 */

export { CategoriesHub } from './Hub';
export { Categories } from './Categories';
export type { CategoriesProps } from './Categories';

export interface VariantManifest {
  slug: string;
  title: string;
}

export const manifest: VariantManifest = {
  slug: 'categories',
  title: 'Categories',
};
